import * as graphql from '@treams/treams-network';

import { parseRevealNumber } from './helpers';

type FormattableRevealValue = {
	value: string;
	type?: graphql.RevealFieldType | null;
};

// Values are stored without a currency code; the backend only detects
// euro-marked columns as CURRENCY, so rendering as EUR is safe.
const REVEAL_CURRENCY = 'EUR';

export const formatRevealValue = (field: FormattableRevealValue, locale: string): string => {
	const type = field.type ?? graphql.RevealFieldType.Text;

	if (type === graphql.RevealFieldType.Text) {
		return field.value;
	}

	const parsed = parseRevealNumber(field.value);
	if (parsed === undefined) {
		return field.value;
	}

	if (type === graphql.RevealFieldType.Currency) {
		return new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: REVEAL_CURRENCY,
		}).format(parsed);
	}

	return new Intl.NumberFormat(locale).format(parsed);
};
